import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=1369a34c&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=1369a34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369a34c",
  null
  
)

export default component.exports